import styled from 'styled-components'

import { Text } from 'src/components/atoms'

const WrapTextSize = styled(Text)<{ fontSize: string }>`
  font-size: ${({ fontSize }) => fontSize || '0'};
`

export { WrapTextSize }
